import { computed } from 'vue'
import { useRoute } from '#imports'

export function useRouteMeta() {
  const route = useRoute()

  return {
    banner: computed(() => route.meta.banner ?? false),
    hideAppHeader: computed(() => route.meta.hideAppHeader ?? false),
    hideAppFooter: computed(() => route.meta.hideAppFooter ?? false),
    returnPath: computed(() => route.meta.returnPath ?? ''),
    isNavigation: computed(() => route.meta.isNavigation ?? false),
    reportReturnPath: computed(() => route.meta.reportReturnPath ?? ''),
  }
}
